<!-- Titre de la partie -->
<div class="container-fluid py-lg-5" id="exp">
    <h2 class="title-work">Expériences professionnelles</h2>



  <!-- 1er job -->
  <div class="row py-lg-4">
    <div class="col-sm-8 offset-sm-2">
        <div class="row">
            <!-- Cercle de gauche -->
            <div class="col-1">
                <!-- On utilise le module ng-in-viewport pour vérifier si notr ecercle est dans le viewport ou pas -->
                <img class="dot round-animate" src="assets/iesi.jfif" />
            </div>
            <!-- Description -->
            <div class="col-10 offset-1">
                <mdb-card class="work-exp">
                    <mdb-card-body>
                        <!-- Intitulé et date -->
                        <h3 class="work-title">Alternance - Développement d'applications en Windev, NodeJS <span class="work-date"> Aout-Juin 2023</span></h3>

                        <!-- Entreprise -->
                        <h2 class="work-entr">IESI à Mérignies contrat de 2 ans </h2>

                        <!-- Description -->
                        <ul>
                            <li> 
                        <p class="work-desc">
                            Création d'un site web en React permettant aux utilisateurs de télécharger et
                            envoyer des fichiers vers un serveur. J'ai également participé à la création de
                            l'API en amont en utilisant NestJS.
                        </p>
                    </li>

                    </ul>

                        <ul>
                            <li>
                                 Développement d’un service qui permet d’envoyer un sms à un abonné sur
                                une ligne de bus.
                            </li>
                            <li>
                                Développement d'une application mobile en Windev Mobile permettant de
                                scanner des plaques d'immatriculation via OCR.
                            </li>
                            <li>
                                Développement d'un logiciel Desktop en Windev permettant le transfert de
                                fichiers d'un système Windows vers un système Linux
                            </li>

                            <li>
                                Création d’une interface qui permet de chiffrer des mots de passe en Windev
                            </li>

                            <li>
                                Création d’un site web en HTML/CSS et javascript qui permet de remplir un
                                formulaire en consommant une API.                            </li>
                         

                        </ul>
                    </mdb-card-body>
                </mdb-card>
            </div>
        </div>
    </div>
</div>

    <!-- 1er job -->
    <div class="row py-lg-2">
        <div class="col-sm-8 offset-sm-2">
            <div class="row">





                <!-- Cercle de gauche -->
                <div class="col-1">
                    <!-- On utilise le module ng-in-viewport pour vérifier si notr ecercle est dans le viewport ou pas -->
                    <img class="dot round-animate" src="assets/creus.jpg" />
                </div>
                <!-- Description -->
                <div class="col-10 offset-1">
                    <mdb-card class="work-exp">
                        <mdb-card-body>
                            <!-- Intitulé et date -->
                            <h3 class="work-title">Stage - Création d'une application de bureau en Wlangage <span class="work-date"> Janvier-Fevrier 2021</span></h3>

                            <!-- Entreprise -->
                            <h2 class="work-entr">Le Creuset à Fresnoy le grand</h2>

                     
                          
                            <ul>
                                <li>
                                    Création d’une application de bureau codée en Wlangage qui vient compléter
                                    L’ERP SAGEX3 gérant les provisions de l’entreprise plus particulièrement les
                                    différents compteurs de temps des salariés pour la comptabilité
                                </li>

                                <li>
                                     Création d'un exécutable à la fin de mon stage.
                                </li>
                                <li>
                                    Création d'un dossier de documentation pour le projet.

                                </li>
                            </ul>
                        </mdb-card-body>
                    </mdb-card>
                </div>
            </div>
        </div>
    </div>

  






    <!-- 2e job -->
    <div class="row py-lg-4">
        <div class="col-sm-8 offset-sm-2">
            <div class="row">
                <!-- Cercle de gauche -->
                <div class="col-1">
                    <!-- On utilise le module ng-in-viewport pour vérifier si notr ecercle est dans le viewport ou pas -->
                    <img class="dot round-animate" src="assets/sslt.jpg" />
                </div>
                <!-- Description -->
                <div class="col-10 offset-1">
                    <mdb-card class="work-exp">
                        <mdb-card-body>
                            <!-- Intitulé et date -->
                            <h3 class="work-title">Stage - Développement d'une application en Java <span class="work-date"> Mai-Juin 2019</span></h3>

                            <!-- Entreprise -->
                            <h2 class="work-entr">Service spécialisé de la logistique et des transports à Denain </h2>

                       
                            <ul>
                                <li>
                                    Création d’une application de bureau codée en Java sous Eclipse permettant de
                                    gérer les cartes de transports des militaires.
                                </li>
                                <li>
                                    Gestion de la base de donnée MySQL.
                                </li>
                                <li>
                                    Création d'un logigramme pour l'application et d'un executable pour le client
                                </li>
                            </ul>
                        </mdb-card-body>
                    </mdb-card>
                </div>
            </div>
        </div>
    </div>


    <!-- 2e job -->
    <div class="row py-lg-4">
        <div class="col-sm-8 offset-sm-2">
            <div class="row">
                <!-- Cercle de gauche -->
                <div class="col-1">
                    <!-- On utilise le module ng-in-viewport pour vérifier si notr ecercle est dans le viewport ou pas -->
                    <img class="dot round-animate" src="assets/has.jfif" />
                </div>
                <!-- Description -->
                <div class="col-10 offset-1">
                    <mdb-card class="work-exp">
                        <mdb-card-body>
                            <!-- Intitulé et date -->
                            <h3 class="work-title"> Animateur en centre de loisirs <span class="work-date"> Juillet 2016- Juillet 2021 </span></h3>

                            <!-- Entreprise -->
                            <h2 class="work-entr">Mairie à Haspres </h2>

                            <!-- Description -->

                            <ul>
                                <li>
                                    Assurer la sécurité des enfants tout en les divertissant.
                                </li>
                                <li>
                                    Organiser des animations de qualité adaptées à l’âge de l’enfant
                                </li>
                                <li>
                                    Vivre et travailler en équipe.

                                </li>
                            </ul>
                        </mdb-card-body>
                    </mdb-card>
                </div>
            </div>
        </div>
    </div>

    <!-- 3nd job -->
    <div class="row py-lg-4">
        <div class="col-sm-8 offset-sm-2">
            <div class="row">
                <!-- Cercle de gauche -->
                <div class="col-1">
                    <!-- On utilise le module ng-in-viewport pour vérifier si notr ecercle est dans le viewport ou pas -->
                    <img class="dot round-animate" src="assets/damp.jfif" />
                </div>
                <!-- Description -->
                <div class="col-10 offset-1">
                    <mdb-card class="work-exp">
                        <mdb-card-body>
                            <!-- Intitulé et date -->
                            <h3 class="work-title">Projet de groupe durant la formation de BTS<span class="work-date"> Juillet-Août 2019</span></h3>

                            <!-- Entreprise -->
                            <h2 class="work-entr">Lycée Dampierre à Valenciennes </h2>

                            <!-- Description -->
                            <li>
                                Creation de site internet de type Ecommerce codé en PHP, MySql, HTML, CSS qui permet de gérer les stocks et les commandes d'un client. <br>
                                <li> Utilisation de l’outil de versioning GitHub
                                </li>
                        </mdb-card-body>
                    </mdb-card>
                </div>
            </div>
        </div>
    </div>
  
    
 
<!-- projet scolaire 2itech -->
<div class="row py-lg-4">
    <div class="col-sm-8 offset-sm-2">
        <div class="row">
            <!-- Cercle de gauche -->
            <div class="col-1">
                <!-- On utilise le module ng-in-viewport pour vérifier si notr ecercle est dans le viewport ou pas -->
                <img class="dot round-animate" src="assets/2ii.png" />
            </div>
            <!-- Description -->
            <div class="col-10 offset-1">
                <mdb-card class="work-exp">
                    <mdb-card-body>
                        <!-- Intitulé et date -->
                        <h3 class="work-title">Projet de groupe durant la formation de CDA<span class="work-date"> Septembre-Juin 2021-2023</span></h3>

                        <!-- Entreprise -->
                        <h2 class="work-entr">2itech Academy à Villeneuve d'Ascq </h2>

                        <!-- Description -->
                        <li>
                            Creation d'une application mobile qui permet de visualiser les salles d'escalades de la Métropole Lilloise <br>
                            <li> Système de chat pour communiquer entre sportifs  </li>
                            <li> Système de connexion,inscription utilisateur  </li>
                            <li> Ajout de salle en favori une fois connecté  </li>
                            <li> Edition du profil, avec une photo de profil </li>
                            <li> Technologies: React Native, Nestjs pour le back-end , Postman pour tester les requêtes HTTP  </li>
                            <li> Mise en production de l'api sur GCP   </li>
                            <li> Création d'une image Docker pour le back-end   </li>
                            <li> 1 branche github par features   </li>

                    </mdb-card-body>
                </mdb-card>
            </div>
        </div>
    </div>
</div>




</div>